import { getSpacerBreakpointValues, mq } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledPageSectionWrapper = styled.div.withConfig({ displayName: "StyledPageSectionWrapper", componentId: "sc-enluhb" }) `
  ${(props) => mq({
    paddingTop: props.hasTopSpacer ? getSpacerBreakpointValues(props.theme, ['x6', null, 'x12']) : [],
    paddingBottom: [props.theme.spacers.x6, null, props.theme.spacers.x18],
})}
`;
export const StyledPageSectionDivider = styled.div.withConfig({ displayName: "StyledPageSectionDivider", componentId: "sc-12c8bhr" }) `
  width: 100%;
  height: ${(props) => props.theme.spacers.x3};

  ${(props) => mq({
    boxShadow: props.theme.shadows.quaternary,
})}
`;
